import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/plugin/element-ui/setup'
import strings from '@/plugin/i18n/setup';
import '@/assets/css/index.scss'

Vue.config.productionTip = false
Vue.use(strings, {defaultLanguage: 'en'})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
